import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { removefriends,friendRejectReq,friendAcceptReq,friendReq,playerFind ,friendFind,reqeustlist ,cancelFriendReq} from '../const';
@Injectable({
  providedIn: 'root'
})
export class FriendsService {

  constructor(private http: HttpClient) { }

  findfriend(data:any){
      return this.http.post<any>(`${friendFind}`,data)  
  } 

  findsortPlayer(data:any,username:any){
      return this.http.post<any>(`${playerFind}?sort=${data}`,username)  
  } 

  findsortfriend(data:any,username:any){
    return this.http.post<any>(`${friendFind}?sort=${data}`,username)  
  }

  findplayer(data:any){
      return this.http.post<any>(`${playerFind}`,data)  
  } 

  
  sentrequestlist(){
      return this.http.post<any>(`${reqeustlist}`,'')  
  } 

  sentrequestCancel(data:any){
      return this.http.post<any>(`${cancelFriendReq}`,data)  
  }

  friendReqeust(data:any){
      return this.http.post<any>(`${friendReq}`,data )  
  }

  removefriend(data:any){
      return this.http.post<any>(`${removefriends}`,data )  
  }

  acceptfriend(data:any){
      return this.http.post<any>(`${friendAcceptReq}`,data )  
  }

  rejectfriend(data:any){
      return this.http.post<any>(`${friendRejectReq}`,data )  
  }

  }
